
import { createApiClient } from 'Network/ApiClient';

export const ActivityErrorsRelationAxiosInstance = createApiClient('user/');


